import { render, staticRenderFns } from "./DocumentTargetPicker.vue?vue&type=template&id=31ad11ec&scoped=true"
import script from "./DocumentTargetPicker.vue?vue&type=script&lang=js"
export * from "./DocumentTargetPicker.vue?vue&type=script&lang=js"
import style0 from "./DocumentTargetPicker.vue?vue&type=style&index=0&id=31ad11ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad11ec",
  null
  
)

export default component.exports